import { ADD_PUDO, UPDATE_PUDO, REMOVE_PUDO, MOVE_PUDO_GROUP, SET_PUDO_GROUPS, CLEAR_PUDO_GROUPS } from 'actions';

// group: { id: string }
// pudo:  { id: string, groupId: string, lat: number, lng: number, address: string,
//          duration: number, assignAt: 'first'|'last', tag?: string }
const initialState = { groups: [], pudos: [] };

export default (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case SET_PUDO_GROUPS:
      return payload;
    case ADD_PUDO: {
      const { group, pudo } = payload;
      const groupExists = state.groups.some((g) => g.id === group.id);
      return {
        groups: groupExists ? state.groups : [...state.groups, group],
        pudos: [...state.pudos, pudo],
      };
    }
    case UPDATE_PUDO: {
      const { id, ...props } = payload;
      return { ...state, pudos: state.pudos.map((p) => (p.id === id ? { ...p, ...props } : p)) };
    }
    case REMOVE_PUDO: {
      const pudos = state.pudos.filter((p) => p.id !== payload);
      const usedGroupIds = new Set(pudos.map((p) => p.groupId));
      return { groups: state.groups.filter((g) => usedGroupIds.has(g.id)), pudos };
    }
    case MOVE_PUDO_GROUP: {
      const { pudoId, newGroupId } = payload;
      const groupExists = state.groups.some((g) => g.id === newGroupId);
      const pudos = state.pudos.map((p) => (p.id === pudoId ? { ...p, groupId: newGroupId } : p));
      const usedGroupIds = new Set(pudos.map((p) => p.groupId));
      return {
        groups: [
          ...state.groups.filter((g) => usedGroupIds.has(g.id)),
          ...(groupExists ? [] : [{ id: newGroupId }]),
        ],
        pudos,
      };
    }
    case CLEAR_PUDO_GROUPS:
      return initialState;
    default:
      return state;
  }
};
